import { SaleModel } from 'api-hooks/sale/common';
import { useGetDetailSale } from 'api-hooks/sale/query';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import Text from 'components/elements/text';
import * as React from 'react';
import { NavigationProps } from 'types';

import ActivityReschedule from './activity';
import CruiseReschedule from './cruise';
import FlightReschedule from './flight';
import HotelReschedule from './hotel';

export type RescheduleParams = {
  data: SaleModel;
  type: 'flight' | 'hotel' | 'cruise' | 'activity';
};

export default function (props: NavigationProps<NavigationRoutes.Reschedule>) {
  const { data, type } = props.navigation.params || {};

  const {
    data: _data,
    isLoading,
    isFetching,
  } = useGetDetailSale({ id: data?.id as string });

  if (isLoading || isFetching) {
    return <LoadingComponent />;
  }

  if (type === 'activity') {
    return <ActivityReschedule {...props} activitySale={_data?.data!} />;
  }

  if (type === 'cruise') {
    return <CruiseReschedule {...props} cruiseSale={_data?.data!} />;
  }

  if (type === 'flight') {
    return <FlightReschedule {...props} flightSale={_data?.data!} />;
  }

  if (type === 'hotel') {
    return <HotelReschedule {...props} hotelSale={_data?.data!} />;
  }

  const detail = {
    invoiceNumber: _data?.data.invoiceNumber,
    invoiceType: _data?.data.transactionType,
    directType: type || 'no-direct-type',
  };

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Text variant="HeadingSmall">Error Reschedule - FE</Text>
      <Text variant="LabelMedium">{JSON.stringify(detail)}</Text>
    </div>
  );
}
